__turbopack_context__.v({
  "action": "WChHqW_action",
  "ant-modal-content": "WChHqW_ant-modal-content",
  "close-btn": "WChHqW_close-btn",
  "disable-scroll-content": "WChHqW_disable-scroll-content",
  "display-scroll": "WChHqW_display-scroll",
  "modal-mobile": "WChHqW_modal-mobile",
  "modal-tablet": "WChHqW_modal-tablet",
  "slideDown": "WChHqW_slideDown",
  "slideUp": "WChHqW_slideUp",
});
